import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  // A fresh client per request (SSR-safe: never share cache between visitors).
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Data stays usable for 5 minutes, so navigating around the site
        // reuses what is already downloaded instead of refetching everything.
        // Freshness after backoffice edits is handled by the content-revision
        // watcher in __root.tsx, which invalidates within ~30s.
        staleTime: 5 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  setupRouterSsrQueryIntegration({ router, queryClient });

  return router;
};
